import type { RootState } from 'state';
import type { HotelProvidersState } from '../slice';

function getHotelProviders(state: RootState): HotelProvidersState['value'] {
  const { value } = state.dataService.productProviders.hotelProviders;
  return value;
}

export default getHotelProviders;
